<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'

import Icon from '../shared/Icon.vue'

import type { AdditionalLinksParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = withDefaults(defineProps<{
  additionalLinks: AdditionalLinksParagraph['additionalLinks'],
  listOrderPosition?: number
}>(), {
  listOrderPosition: 0
})

const showAll = ref(false)

const ariaLabel = computed(() =>
  showAll.value ? 'Mehr zum Thema einklappen' : 'Mehr zum Thema ausklappen'
)

const ariaExpanded = computed(() => showAll.value)

const ariaControlsId = computed(() =>
  `bx-additional-links-${props.listOrderPosition}`
)

onMounted(() => {
  showAll.value = props.additionalLinks?.length === 3
})
</script>

<template>
  <div class="bx-content bx-additional-links bx-typo--additional-links"
       :class="{'bx-js-additional-links-hide': !showAll}">
    <ul :id="ariaControlsId">
      <li v-for="link in props.additionalLinks ?? []"
          :key="link?.url">
        <a :href="link?.url"
           class="bx-additional-links__link">
          {{ link?.text }}
        </a>
      </li>
    </ul>
    <button v-if="props.additionalLinks?.length > 3"
            type="button"
            :aria-controls="ariaControlsId"
            :aria-label="ariaLabel"
            :aria-expanded="ariaExpanded"
            @click="showAll = !showAll">
      <span>{{ ariaLabel }}</span>
      <Icon name="arrow_toggle" />
    </button>
  </div>
</template>
